<template>
  <div class="full-width-overflow-y" :style="styleObj"  >

    <div style=" padding: 15px;text-align: left;">
      <el-button  @click="click3DLand" style="margin-left: 8px; border: 1px ;min-width: 150px;" >
        <img :src="`${publicPath}static/images/ShopopeeLogo.png`" style="width: 50px; height: 50px;user-select:none;"
             onerror="this.error = null"/>
      <span class="text-large font-600 mr-3" > {{returnLabel}} </span>
      </el-button>
      <el-button circle @click="clickchangeLange2" style="margin-left: 8px;" >
        <font-awesome-icon icon="fa-solid fa-language" />
      </el-button>

    </div>
    <div class="page-part-full" v-loading="loading"  >
      <div style="display: flex;flex-direction: column;align-items: center;" v-if="isErrer">
      <img :src="`${publicPath}static/images/ShopopeeLogo.png`" style="width: 150px; height: 150px;user-select:none;"
           onerror="this.error = null"/>
        <el-text style="font-size: larger;padding: 15px 0px;">{{i18n.tkey("lang_my_3D_shop")}} {{i18n.tkey("lang_not_exist")}}</el-text>
      <el-button  @click="click3DLand" style="margin-left: 8px;min-width: 150px;" >

        <span class="text-large font-600 mr-3" > {{i18n.tkey("lang_goto")}}{{returnLabel}} </span>
      </el-button>
      </div>
    </div>

  </div>

  <languageSelect v-if="langSelectVisible2 == true" @save-complete="langSelectVisible2 = false" />
</template>

<script setup>
import record15Api from "@/request/record15Api";
import myUtil from "@/util/util";
import {computed, getCurrentInstance, inject, onBeforeMount, onMounted, ref} from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {faLanguage} from '@fortawesome/free-solid-svg-icons'
import {library} from "@fortawesome/fontawesome-svg-core";
import languageSelect from "@/components/Shopopee3D/ui/languageSelect.vue";
const publicPath = process.env.BASE_URL
const { proxy } = getCurrentInstance()
const i18n = inject("i18n")

const props = defineProps(['countrycode', 'shopid'])
const styleObj = ref({})
//是否顯示語言選擇框
const langSelectVisible2 = ref(false)
const loading = ref(false)
const  isErrer =  ref(false)

library.add(faLanguage)
const returnLabel = computed(() => {
  let name = i18n.tkey('lang_3d_business_city')


  return name
})

function click3DLand(){
  proxy.$router.push({name: "demoIndex"})
}

function getHallRecord15ByPage(){

  loading.value = true
  const request = record15Api.queryAdditionalrecord15Position
  const params = request.getParams()

  //const countrycode = props.countrycode
  params.id = props.shopid
  console.log(params)
  request.send(params, (res) => {
    loading.value = false
    if (res.code == 200){
      var data = res.detail
      console.log(data)
      if(myUtil.isNotEmpty(data) ){
      var conutrycode = props.countrycode
        if(myUtil.isEmpty(conutrycode)){
          conutrycode = "HK"
        }

        location.href = `${proxy.$ThreeDShopopeePath}${data.updatedid}/index/${props.countrycode}/${data.addinfo1}/${data.addinfo2}`

      }else{

        isErrer.value=true
      }

    }else{
      myUtil.alertError(res.msg)
      isErrer.value=true
    }
  })
}
function clickchangeLange2(){
  langSelectVisible2.value=true;
}
onBeforeMount(() => {
  styleObj.value = {
    width: `${window.innerWidth}px`,
    height: `${window.innerHeight}px`
  }
})

onMounted(() => {
  getHallRecord15ByPage()
})
</script>

<style scoped>
.full-width-overflow-y{
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  text-align: left;
  position: relative;
}
.page-part-full{
  width: calc(100% - 30px);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;

}

</style>